import { useContext, useEffect, useState } from 'react';

import { Formik } from 'formik';
import queryString from 'query-string';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import * as Yup from 'yup';

import { EventContext } from '../../Contexts/EventContext';
import Datepicker from '../../Shared/Components/Datepicker';
import Loading from '../../Shared/Components/Loading';
import ModalCustom from '../../Shared/Components/ModalCustom';
import Pagination from '../../Shared/Components/Pagination';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import useQuery from '../../Shared/queryString';
import { getStoredAuthToken } from '../../Shared/utils/authToken';
import { baseApiUrl, number_format } from '../../Shared/utils/helper';
/** @format */
import Master from '../Layouts/Master';

const validationSchema = Yup.object({});

const Transaction = () => {
  const eventContext = useContext(EventContext);
  const { search } = useLocation();
  const transactionTracking = useQuery.getParam('transaction_tracking');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [formRemoveId, setFormRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [issueTracking, setIssueTracking] = useState('');
  const [filterModal, setFilterModal] = useState(false);
  const [parseParams, setParseParams] = useState({});

  useEffect(() => {
    const params = queryString.parse(search);
    setParseParams(params);
    if (transactionTracking != null) {
      setIssueTracking(transactionTracking);
    }
    getProvinces();
    getTransactionsInfo();
    getTransaction();
  }, [search]);

  const getProvinces = async () => {
    await useApi.get(
      '/province',
      {},
      (res) => {
        eventContext.provinces = res.data.data;
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };

  const getTransactionsInfo = async () => {
    await useApi.get(
      `/transaction/info${search}`,
      {},
      (res) => {
        eventContext.transactionsInfo = res.data.data;
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };

  const getTransaction = async () => {
    setLoading(true);
    await useApi.get(
      `/transaction${search}`,
      {},
      (res) => {
        eventContext.transactions = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  const removeForm = async (transactionId) => {
    setRemoveLoading(true);

    await useApi.delete(
      `/transaction/${transactionId}`,
      {},
      (res) => {
        success('تراکنش مورد نظر با موفقیت حذف شد');
        setRemoveLoading(false);
        setModalIsOpen(false);
        getTransaction();
      },
      (err) => {
        setRemoveLoading(false);
        setLoading(false);
        error('حذف به علت خطا انجام نشد');
      },
    );
  };
  const searchByIssueTracking = () => {
    let issue =
      issueTracking.length > 0 ? `?transaction_tracking=${issueTracking}` : '';
    return navigate(`/panel/transaction${issue}`);
  };

  const transactionFilter = (values, setSubmiting) => {
    let regexPaginate = new RegExp(/page=([0-9]+)/);
    let pageExists = regexPaginate.test(search);
    let paginate = parseParams?.page;

    let filter = pageExists ? `?page=${paginate}` : '';
    Object.entries(values).forEach((item) => {
      if (item[1] != 0 || item[1]?.length > 0) {
        filter +=
          filter.length > 0
            ? `&${item[0]}=${item[1]}`
            : `?${item[0]}=${item[1]}`;
      }
    });
    navigate(`/panel/transaction${filter}`);
    setFilterModal(false);
  };

  const getExcelExportUrl = () => {
    let baseUrl = `${baseApiUrl()}/transaction/excel-report?token=${getStoredAuthToken()}`;

    Object.entries(parseParams).forEach((item) => {
      if (item[1] != 0 || item[1]?.length > 0) {
        baseUrl +=
          baseUrl.length > 0
            ? `&${item[0]}=${item[1]}`
            : `?${item[0]}=${item[1]}`;
      }
    });

    return baseUrl;
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست تراکنش ها
          </h1>
        </div>
        <div className='d-flex flex-row align-items-center'>
          <button
            onClick={() => setFilterModal(true)}
            className='d-flex flex-row btn btn-outline-info mx-2'
          >
            <i className='fad fa-filter f-16 mx-2'></i>
            <span className='f-13'>فیلتر</span>
          </button>
          <a
            href={getExcelExportUrl()}
            className='d-flex flex-row btn btn-outline-info mx-2'
          >
            <i className='fas fa-file-excel f-16 mx-2'></i>
            <span className='f-13'>خروجی اکسل</span>
          </a>
        </div>
      </div>
      {/* <div className='d-flex flex-row w-100 my-1'>
        <div className='form-group w-50'>
          <label className='f-14 text-right'>کد پیگری (شماره صورت حساب )</label>
          <input
            type='text'
            value={issueTracking}
            onChange={(e) => setIssueTracking(e.target.value)}
            className='form-control'
          />
        </div>
        <div className='form-group mt-2'>
          <button
            onClick={searchByIssueTracking}
            className='btn bg-purple f-12 mt-4 mx-2 text-dark-mode'
          >
            جستجو
          </button>
        </div>
      </div> */}
      <div className='row my-3'>
        <div className='col-12 col-md-4 my-2'>
          <div className='d-flex flex-row align-items-center'>
            <span className='text-dark f-14 mx-2'>تعداد همه تراکنش ها : </span>
            <span className='text-dark f-14 mx-2'>
              {eventContext?.transactionsInfo?.all_count}
            </span>
          </div>
        </div>
        <div className='col-12 col-md-4 my-2'>
          <div className='d-flex flex-row align-items-center'>
            <span className='text-success f-14 mx-2'>
              تعداد تراکنش های موفق :{' '}
            </span>
            <span className='text-success f-14 mx-2'>
              {eventContext?.transactionsInfo?.success_count}
            </span>
          </div>
        </div>
        <div className='col-12 col-md-4 my-2'>
          <div className='d-flex flex-row align-items-center'>
            <span className='text-danger f-14 mx-2'>
              تعداد تراکنش های ناموفق :{' '}
            </span>
            <span className='text-danger f-14 mx-2'>
              {eventContext?.transactionsInfo?.failed_count}
            </span>
          </div>
        </div>

        <div className='col-12 col-md-4 my-2'>
          <div className='d-flex flex-row align-items-center'>
            <span className='text-dark f-14 mx-2'>مبلغ همه تراکنش ها : </span>
            <span className='text-dark f-14 mx-2'>
              {number_format(eventContext?.transactionsInfo?.all_price)} تومان
            </span>
          </div>
        </div>
        <div className='col-12 col-md-4 my-2'>
          <div className='d-flex flex-row align-items-center'>
            <span className='text-success f-14 mx-2'>
              مبلغ تراکنش های موفق :{' '}
            </span>
            <span className='text-success f-14 mx-2'>
              {number_format(eventContext?.transactionsInfo?.success_price)}{' '}
              تومان
            </span>
          </div>
        </div>
        <div className='col-12 col-md-4 my-2'>
          <div className='d-flex flex-row align-items-center'>
            <span className='text-danger f-14 mx-2'>
              مبلغ تراکنش های ناموفق :{' '}
            </span>
            <span className='text-danger f-14 mx-2'>
              {number_format(eventContext?.transactionsInfo?.failed_price)}{' '}
              تومان
            </span>
          </div>
        </div>
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.transactions?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>کاربر</th>
                <th>تیم/سرپرست</th>
                <th>رویداد</th>
                <th>مبلغ تراکنش</th>
                <th>شماره کارت پرداخت کننده</th>
                <th>شماره صورت حساب</th>
                <th>وضعیت تراکنش</th>
                <th>تاریخ تراکنش</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.transactions?.data?.map((item) => (
                <tr key={item.id}>
                  <th>{item.id}</th>
                  <td>
                    {item?.user?.first_name ?? ''}{' '}
                    {item?.user?.last_name ?? '-'}
                  </td>
                  <td>
                    {item?.event?.type == 2
                      ? item?.team?.club_name
                      : item?.event?.type == 3
                      ? `${item?.team?.supervisor?.first_name} ${item?.team?.supervisor?.last_name}`
                      : '-'}
                  </td>
                  <td>{item?.event?.title}</td>
                  <td>{number_format(item?.amount)} تومان</td>
                  <td dir='ltr'>{item?.card_number}</td>
                  <td>{item?.invoice_number}</td>
                  <td>
                    {item?.status == 0 ? (
                      <span className='badge badge-danger badge-pill p-2'>
                        پرداخت نشده
                      </span>
                    ) : (
                      <span className='badge badge-success badge-pill p-2'>
                        پرداخت شده
                      </span>
                    )}
                  </td>
                  <td>{item?.invoice_date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <i className='fad fa-plus f-16 mx-2 text-secondary'></i>
            <span className='f-13 font-weight-bold text-secondary'>
              تراکنشی وجود ندارد
            </span>
          </div>
        )}
      </div>

      <div className='w-100 mt-4 d-flex'>
        <Pagination
          totalPage={eventContext.transactions?.meta?.pagination?.total_pages}
          basePath={`/panel/transaction`}
          search={search}
        />
      </div>
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>آیا از حذف فرم مطمئنید‌؟</span>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          <button
            onClick={() => removeForm(formRemoveId)}
            className='btn btn-success w-48 f-13'
          >
            {removeLoading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'بله'
            )}
          </button>
        </div>
      </ModalCustom>

      <ModalCustom modalIsOpen={filterModal}>
        <div className='d-flex flex-row justify-content-between align-items-center border-bottom pb-2'>
          <span className=''>فیلتر تراکنش ها</span>
          <i
            className='far fa-times text-white f-20 mx-2 c-pointer'
            onClick={() => setFilterModal(false)}
          ></i>
        </div>
        <div className='w-100 my-3 owerflow-auto'>
          <Formik
            initialValues={{
              province_id: parseParams?.province_id ?? 0,
              event_name: parseParams?.event_name ?? '',
              start_at: parseParams?.start_at ?? '',
              end_at: parseParams?.end_at ?? '',
              status: parseParams?.status ?? 2,
              transaction_tracking: parseParams?.transaction_tracking ?? '',
            }}
            onSubmit={transactionFilter}
            validationSchema={validationSchema}
          >
            {({
              handleSubmit,
              handleChange,
              values,
              errors,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-12 col-md-6'>
                    <div className='form-group'>
                      <label className='text-white f-13'>استان</label>
                      <select
                        className='form-control w-100'
                        onChange={handleChange}
                        value={values.province_id}
                        name='province_id'
                      >
                        <option value='0'>همه</option>
                        {eventContext.provinces?.map((province) => (
                          <option key={province?.id} value={province?.id}>
                            {province?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className='col-12 col-md-6'>
                    <div className='form-group'>
                      <label className='text-white f-13'>نام رویداد</label>
                      <input
                        type='text'
                        className='form-control w-100'
                        onChange={handleChange}
                        value={values.event_name}
                        name='event_name'
                      />
                    </div>
                  </div>

                  <div className='col-12 col-md-6'>
                    <div className='form-group'>
                      <div className='d-flex flex-column mx-1'>
                        <label className='text-white f-13'>
                          شروع بازه زمانی
                        </label>
                        <Datepicker
                          name='start_at'
                          handleChange={setFieldValue}
                          value={values.start_at}
                          minDate='1350/01/01'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-md-6'>
                    <div className='form-group'>
                      <div className='d-flex flex-column mx-1'>
                        <label className='text-white f-13'>
                          پایان بازه زمانی
                        </label>
                        <Datepicker
                          name='end_at'
                          handleChange={setFieldValue}
                          value={values.end_at}
                          minDate='1350/01/01'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-md-6'>
                    <div className='form-group'>
                      <label className='text-white f-13'>وضعیت تراکنش</label>
                      <select
                        className='form-control w-100'
                        onChange={handleChange}
                        value={values.status}
                        name='status'
                      >
                        <option value='2'>همه</option>
                        <option value='1'>موفق</option>
                        <option value='0'>ناموفق</option>
                      </select>
                    </div>
                  </div>
                  <div className='col-12 col-md-6'>
                    <div className='form-group'>
                      <label className='text-white f-13'>
                        کد پیگری (شماره صورت حساب )
                      </label>
                      <input
                        type='text'
                        className='form-control w-100'
                        onChange={handleChange}
                        value={values.transaction_tracking}
                        name='transaction_tracking'
                      />
                    </div>
                  </div>
                  <div className='col-12 d-flex flex-row justify-content-center align-items-center'>
                    <span
                      className='btn px-5 btn-danger text-white f-12 my-3 mx-2 c-pointer'
                      onClick={() => setFilterModal(false)}
                    >
                      انصراف
                    </span>
                    <button className='btn px-5 btn-info text-white f-12 my-3'>
                      فیلتر
                    </button>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default Transaction;
